export enum TRibbonVariant {
  NEWS = 'news',
  DANGER = 'danger',
}
